import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ palette }) => ({
  listItem: {
    height: 60,
    borderBottom: '1px solid #E0E0E0',
    '&:hover': {
      backgroundColor: palette.background.selected
    }
  }
}))
